import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";

export const CalendarDashboardLearnerSpeakerApi = createApi({
  reducerPath: "calendarDashboardLearnerSpeakerApi",
  baseQuery: customBaseQuery,
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    getAgendasForSpeaker: builder.query({
      query: (body: any) => {
        return {
          url: `/search/agenda/speaker`,
          method: "POST",
          body: body
        };
      }
    })
  })
});

export const { useGetAgendasForSpeakerQuery } =
  CalendarDashboardLearnerSpeakerApi;
